import { Check, Sparkles } from "lucide-react";

import { cn } from "@/lib/utils";

/**
 * Pantalla de espera mientras se guarda la línea y se busca el primer resultado.
 * Los checks siguen a las peticiones reales, no a un temporizador.
 */
export function SearchingStep({
  headline,
  lineSaved,
  resultReady,
}: {
  headline: string;
  lineSaved: boolean;
  resultReady: boolean;
}) {
  const steps = [
    { label: `Buscando ${headline} en expedientes técnicos`, done: lineSaved },
    { label: "Sumando cantidades y potencial de venta", done: resultReady },
    { label: "Encontrando a los ganadores de la buena pro", done: resultReady },
  ];

  return (
    <div className="mx-auto w-full max-w-[720px] flex min-h-[60vh] flex-col justify-center">
      <div className="relative flex size-[76px] items-center justify-center">
        <span className="absolute inset-0 animate-spin rounded-full border-[3px] border-emerald-100 border-r-emerald-600" />
        <span className="flex size-12 items-center justify-center rounded-full bg-white shadow-sm">
          <Sparkles className="size-5 text-emerald-600" />
        </span>
      </div>

      <h1 className="mt-7 max-w-[560px] text-[30px] font-extrabold leading-[1.1] tracking-[-0.03em] text-slate-900 sm:text-[38px]">
        Buscando quién necesita {headline}…
      </h1>

      <ul className="mt-6 space-y-3">
        {steps.map((step) => (
          <li key={step.label} className="flex items-center gap-3 text-[15px]">
            <span
              className={cn(
                "flex size-6 shrink-0 items-center justify-center rounded-full transition-colors",
                step.done ? "bg-emerald-600 text-white" : "bg-white text-slate-300",
              )}
            >
              <Check className="size-3.5" strokeWidth={3} />
            </span>
            <span className={step.done ? "text-slate-800" : "text-slate-400"}>
              {step.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
